export default function mapPermissionsToNodes(permissions, grant) {
    return permissions.map(permission => {
        if(permission.grant === grant)
            return { id: permission.nodeId };
    }).filter(permission => typeof permission !== "undefined");

}
